import React from 'react';
import PropTypes from 'prop-types';
import Price from './Price';

const PriceTypeOption = ({ priceType, disabled, handleSelection }) => {
  return (
    <div className="syos-pricetype-unit">
      <span className="syos-pricetype-unit__details">
        <Price priceData={priceType} isStacked={true} />
      </span>
      <span className="syos-pricetype-unit__action">
        <button className="syos-button" disabled={disabled} onClick={handleSelection}>
          Select
        </button>
      </span>
    </div>
  );
};
PriceTypeOption.propTypes = {
  handleSelection: PropTypes.func,
  priceType: PropTypes.shape({
    price_type_alias_desc: PropTypes.string,
    price_type_desc: PropTypes.string,
    price: PropTypes.number
  }),
  disabled: PropTypes.bool,
};

PriceTypeOption.defaultProps = {
  disabled: false,
};

export default PriceTypeOption;



// WEBPACK FOOTER //
// ./src/javascripts/components/PriceTypeOption.js